import React, { useContext } from "react";
import { GlobalState } from "../../data/Context";
import { buildAssetUrl } from "../../data/authStorage";

export default function PayslipBrand() {
  const { organization } = useContext(GlobalState);
  const organizationName = organization?.name || "Organization";
  const logo = buildAssetUrl(organization?.logoUrl || organization?.logo || organization?.image);
  const initials = organizationName.split(/\s+/).map((part) => part[0]).slice(0, 2).join("").toUpperCase();

  return <div className="payslip-brand mb-4 flex items-center gap-3 border-b border-slate-100 pb-4">
    <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-100 bg-white p-1.5 shadow-sm">
      {logo ? <img src={logo} alt={`${organizationName} logo`} className="h-full w-full object-contain" /> : <span className="text-base font-black text-[#1234CD]">{initials}</span>}
    </div>
    <div className="min-w-0">
      <p className="truncate text-sm font-bold text-[#071C50]">{organizationName}</p>
      <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400">Official payslip</p>
    </div>
  </div>;
}
